// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"styles-module__closeIcon___1oAGK","arrowIcon":"styles-module__arrowIcon___2TwmO","arrowIconReversed":"styles-module__arrowIconReversed___2teII"};